import * as Icons from "heroicons-react";
import { Link } from "react-router-dom";
import defaultLogo from "../../../../logo.svg";
import { signInUser } from "../../../Utility/Auth";
import { useSettingsQuery } from "../../../../services/settingsApi";
import { getDisplayLogo } from "../../../Utility/packageHelper";

const PosHeader = ({ logo }) => {
  const auth = signInUser() || {};
  const { aamarId } = auth;
  const { data: dbSettings } = useSettingsQuery(aamarId, { skip: !aamarId });

  const displayLogo = getDisplayLogo(auth, dbSettings, defaultLogo);

  return (
    <nav className="d-flex justify-content-between align-items-center mt-1">
      <div className="d-flex align-items-center">
        <Link to="/">
          <img
            src={displayLogo}
            alt="Logo"
            style={{
              maxWidth: "150px",
              maxHeight: "45px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.target.src = defaultLogo;
            }}
          />
        </Link>
        <sup>
          <h2
            className="border border-success rounded text-success"
            style={{
              fontSize: "0.75rem", // Smaller font size
              backgroundColor: "#d4edda", // Light green background
              padding: "2px 6px", // Smaller padding
              borderRadius: "4px", // Smaller rounded corners
            }}
          >
            Secured
          </h2>
        </sup>
      </div>

      <span className="float-end">
        <Link
          className="btn btn-dark pull-end mr-auto px-3 py-2"
          to="/dashboard"
        >
          Exit <Icons.LogoutOutline className="ms-2" size={20} />{" "}
        </Link>
      </span>
    </nav>
  );
};

export default PosHeader;

